// Base
import { DetailedHTMLProps, HTMLAttributes } from 'react'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'
import { UrlObject } from 'url'

// Packages
import { Link } from 'react-scroll'

// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import NextLink from './next-link/NextLink'

// Styles
import styles from './Navigation.module.sass'

interface NavigationProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  active: boolean
  sectionLink?: string
  signUpLink?: string
  closeMenu: () => void
}

const Navigation = ({
  active,
  closeMenu,
  sectionLink = '/v25/es/home',
  signUpLink,
  ...rest
}: NavigationProps) => {
  const pathname = usePathname()
  const router = useRouter()

  const handleClick = (section: string) => {
    if (!pathname?.includes('home')) {
      router.push(`${sectionLink}#${section}`)
    }

    closeMenu()
  }

  return (
    <nav className={`${styles.nav} ${active ? styles.active : ''}`} {...rest}>
      <Box backgroundColor="grey-5">
        <Flex flexDirection="column" rowGap={{ sm: 1 }}>
          <NavLink
            id="how-it-works-anchor"
            onClick={() => handleClick('how-it-works-anchor')}
          >
            Cómo funciona
          </NavLink>
          <NavLink
            id="recent-deals-anchor"
            onClick={() => handleClick('recent-deals-anchor')}
          >
            Ofertas recientes
          </NavLink>
          <NavLink
            id="reviews-anchor"
            onClick={() => handleClick('reviews-anchor')}
          >
            Comentarios
          </NavLink>
          <NavLink id="faq-anchor" onClick={() => handleClick('faq-anchor')}>
            Preguntas frecuentes
          </NavLink>

          <NavLink href={signUpLink}>Registrarse</NavLink>
        </Flex>
      </Box>
    </nav>
  )
}

interface NavLinkProps {
  children: React.ReactNode
  id?: string
  onClick?: () => void
  href?: string | UrlObject
}

const NavLink = ({ children, id, onClick, href }: NavLinkProps) => {
  return (
    <NavWrapper id={id} href={href} onClick={onClick}>
      <Box backgroundColor="white" padding={{ sm: [16] }}>
        <Text variant="body-1" transform="uppercase" fontWeight={500}>
          {children}
        </Text>
      </Box>
    </NavWrapper>
  )
}

interface NavWrapperProps {
  href?: string | UrlObject
  id?: string
  onClick?: () => void
  children: React.ReactNode
}

const NavWrapper = ({ href, id, onClick, children }: NavWrapperProps) => {
  if (href) {
    return <NextLink href={href}>{children}</NextLink>
  }

  if (id) {
    return (
      <Link to={id} onClick={onClick}>
        {children}
      </Link>
    )
  }

  return <div>{children}</div>
}

export default Navigation
